import Assets from "../../../assets/Assets";
import Style from "./adminProfileCard.module.scss";

const AdminProfileCard = ({
  userData,
  imagePreview,
  handleImageChange,
  profileFileInputRef,
}) => {
  const handleClick = () => {
    profileFileInputRef.current.click();
  };

  return (
    <div className={Style.root}>
      <div className={Style.img_wrap}>
        <figure className="pro-mb-0">
          {imagePreview ? (
            <img src={imagePreview} alt="staff_image" />
          ) : imagePreview === null && userData?.full_name === "Super Admin" ? (
            <img src={Assets.ACCOUNT_CIRCLE} alt="staff_image" />
          ) : (
            <img src={Assets.GENDER_IMAGE} alt="staff_image" />
          )}
        </figure>
        {userData?.full_name !== "Super Admi" ? (
          <span className={Style.editProfile} onClick={handleClick}>
            {" "}
            <span className="material-symbols-outlined">edit</span>
          </span>
        ) : (
          <></>
        )}
      </div>
      <div className="pro-ps-4 pro-pt-1 pro-pb-2 pro-d-flex pro-flex-column">
        {userData?.full_name && (
          <h4 className="pro-ttl h4 pro-mb-1">{userData?.full_name ?? " "}</h4>
        )}
        {
          <p className="pro-mb-2">{`${userData?.dialcode}-${userData?.personal_number}`}</p>
        }
        <ul
          className={`pro-d-flex pro-align-center ${
            userData?.branch?.name ? Style.list : ""
          }`}
        >
          <li>{userData?.email ?? ""}</li>
          <li>{userData?.branch?.name ?? ""}</li>
        </ul>
      </div>

      <div className={Style.file_container}>
        <div className="input-drag">
          <input
            type="file"
            accept=".jpeg, .jpg , .png"
            ref={profileFileInputRef}
            className={`pro-input ${" error"}`}
            style={{ display: "none" }}
            id="profile"
            name="profile"
            onChange={(e) => handleImageChange(e)}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminProfileCard;
